/*
 * @Date: 2024-07-26 12:58:52
 * @LastEditors: p彭 9878922+p-pengrulin@user.noreply.gitee.com
 * @LastEditTime: 2024-10-05 14:50:06
 */
import Request from "./commonRequest";

/**
 * @description: 模拟登录
 */
export const login = (address) => {
  return new Request(`/auth/mock-login`).Post({
    data: { address },

    mockedUrl: "/dev/auth/mock-login",
  });
};

/**
 * @description: 获取nonce
 */
export const getNonce = (address) => {
  return new Request(`/auth/nonce`).Get({
    mockedUrl: "/dev/auth/nonce",
  });
};

/**
 * @description: 登出
 */
export const logout = () => {
  return new Request(`/auth/logout`).Post({
    mockedUrl: "/dev/auth/logout",
  });
};

/**
 * @description: 登录
 */
export const verify = (data) => {
  return new Request(`/auth/verify:siws`).Post({
    data,
    mockedUrl: "/dev/auth/verify:siws",
  });
};

/**
 * @description: 链接邮箱
 */
export const putLinkEmail = (data) => {
  return new Request(`/public/user/current/email`).Put({
    data,
    mockedUrl: "/dev/public/user/current/email",
  });
};

/**
 * @description: 获取用户信息
 */
export const getUserInfo = (address) => {
  return new Request(`/public/user/current`).Get({
    mockedUrl: "/dev/public/user/current",
  });
};

/**
 * @description: 绑定引荐人
 */
export const referralBind = (parentCode) => {
  return new Request(`/public/referral/bind?parentCode=${parentCode}`).Post({
    mockedUrl: "/dev/public/referral/bind",
  });
};

/**
 * @description: 获取默认活动key
 */
export const getActivity = () => {
  return new Request(`/public/point/activity/default`).Get({
    mockedUrl: "/dev/public/point/activity/default",
  });
};
